module.exports = __webpack_public_path__ + "img/流体力学6_4.a8fa6e75.jpg";